<script>
  import { quintOut } from 'svelte/easing'
  import { fly } from 'svelte/transition'

  /** @type {'left'|'right'} */
  export let align = 'left'
</script>

<div
  class="dropdown {align}"
  in:fly={{ y: '20%', duration: 500, easing: quintOut }}
  on:outrostart
  on:outroend>
  <slot />
</div>

<style>
  .dropdown {
    width: calc(100vw - var(--document-margin) * 2);
    padding: clamp(1.25rem, 3vw, 1.75rem);
    position: absolute;
    top: calc(100% + clamp(0.5rem, min(2vh, 3vw), 1rem) * 2);
    left: 50%;
    transform: translateX(-50%);
    background: var(--background);
    border-radius: var(--border-radius-lg);
    box-shadow: var(--box-shadow-lg);
  }

  @media (orientation: landscape) {
    .dropdown {
      max-height: 60vh;
      overflow: auto;
    }
  }

  @media (width >= 1000px) {
    .dropdown {
      width: min(28rem, 100vw - var(--document-margin) * 2);
    }

    .dropdown.left {
      left: 0;
      transform: none;
    }

    .dropdown.right {
      right: 0;
      left: auto;
      transform: none;
    }
  }
</style>
